import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from "../services/storage.service";
import { CryptoService } from '../security/crypto.service';

@Injectable()
export class AuthGuard {
    constructor(
      private router: Router,
      private storageService: StorageService,
      private cryptoService: CryptoService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const user = this.storageService.getCurrentUser(); 

      // if (this.storageService.isAuthenticated()) {
      //   return true;
      // }
      // this.router.navigate(['/login']);
      // return false;

      if (!this.storageService.isAuthenticated()) { 
        this.router.navigate(['/login']);
        return false;
      }

      // si el serverTime está en 0, se redirige al login
      if (!this.cryptoService.getServerTime()) {
        this.setLogoutSession();
        return false;
      }

      // 2️⃣ Validar estructura real
      if (!user || !user.rol || typeof user.rol.id !== 'number') {  
        // this.router.navigate(['/login']);
        this.setLogoutSession();
        return false;
      }

      const rolIdUsuario = user.rol.id;
      const rolesPermitidos = route.data && route.data['roles'];      
      const permisosRequeridos = route.data && route.data['permisos']; 
      
      if (!rolesPermitidos && !permisosRequeridos) {
        return true;
      }

      if (rolesPermitidos && rolesPermitidos.indexOf(rolIdUsuario) === -1) { 
        // this.router.navigate(['/login']);
        this.setLogoutSession();
        return false;
      }

      if (rolIdUsuario === 1) {
        return true;
      }

      // 🔐 Para rol 2 validar permisos
      if (rolIdUsuario === 2) {
        if (permisosRequeridos && permisosRequeridos.length) {

          const permisosUsuarioIds = Array.isArray(user.permisos)
            ? user.permisos.map((p: any) => p.id)
            : [];

          const tienePermiso = permisosRequeridos.some(id => permisosUsuarioIds.indexOf(id) !== -1);

          if (!tienePermiso) { 
            // this.router.navigate(['/login']);
            this.setLogoutSession();
            return false;
          }
        }
      }

      return true;
      
    }

    setLogoutSession() {
      this.storageService.logout();
    }

 
}




// WEBPACK FOOTER //
// ./src/app/guards/auth-guard.ts